export default __webpack_public_path__ + "2b91cb51191c0f058154e2c1400877c6.png";